import React, { useContext, useState } from 'react';
import './FileUpload.css'
import EmployeeContext from '../../../utils/EmpDetails/EmployeeProvider';
import { Alert } from '../../../utils/Alert';
import { uploadFile } from '../../../services/uploadservice';
import { gaEvent } from '../../../utils/GoogleAnalytics/gatracking';

const FileUpload = ({glid, getAttachmentPath, getFiles}) => {
  const employeeDetails = useContext(EmployeeContext);

  const fileValidator = async (file) => {
    var fileSize = file.size;
    /* 1024 = 1MB */
    var size = Math.round((fileSize / 1024));
    var filePath = file.name;
    // Allowing file type
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.zip|\.pdf|\.doc|\.docx|\.pdf|\.xls|\.xlsx|\.csv)$/i;

    if (!allowedExtensions.exec(filePath)) {
      Alert('Invalid file type. Allowed file extensions are jpg, jpeg, pdf, doc, docx, xls, xlsx, csv, zip');
      return false;
    } else if (size >= 10 * 1024) {
      Alert("Invalid file size, please select a file less than or equal to 10mb size");
      return false;
    }	else {
      return true;
    }
  }

  const handleFileChange = async (event) => {
    getFiles(event.target.files);
    gaEvent("Choose File Button", "Choose File", "click", "Choose File", glid);
    if (event.target.files.length > 0) {
      try {
        const validate = await fileValidator(event.target.files[0]);
        if (!validate) {
          getFiles({});
          throw Error("File validation failed");
        } else {
          const response = await uploadFile(employeeDetails.EMPLOYEEID, employeeDetails.ak, glid, event.target.files[0]);
          if (response.status === 200) {
            Alert("Attachment uploaded successfully!!");
            // Alert(JSON.stringify(response.data));
            getAttachmentPath("Attachment Path : https://weberp.intermesh.net/Misc/ShowAttach.aspx?ImagePath=" + response.data.Data?.AwsPath?.Image_Original_Path);
            gaEvent("Choose File Button", "Attachment uploaded successfully popup", "click", "Attachment uploaded successfully - ok", glid);
          } else {
            getFiles({});
            Alert('Upload Failed');
          }
        }
      } catch (error) {
        getFiles({});
        console.error('Error:', error);
        Alert('Upload Failed');
      }
    }
  };

  return (
    <div>
      <div className="file-upload">
        <input
          id="file"
          type="file"
          className="file-input"
          onChange={handleFileChange}
        />
        <label htmlFor="file" className="fileloadbutton">
          Choose File
        </label>
      </div>
    </div>
  );
};

export default FileUpload;
